import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import axios from 'axios';
import {
  CLIENT_USERS_LIST_API,
  DEPARTMENT_LIST_API,
  VISITOR_TYPES_LIST_API,
  VISIT_PURPOSE_LIST_API
} from '../../utils/api';

function VisitInfoTab({ form, setForm, handleChange }) {
  const [departments, setDepartments] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [visitorTypes, setVisitorTypes] = useState([]);
  const [visitPurposes, setVisitPurposes] = useState([]);

  const token = localStorage.getItem('token');
  const decoded = JSON.parse(atob(token));
  const customer_id = decoded.customer_id;

  useEffect(() => {
    fetchDepartments();
    fetchVisitorTypes();
    fetchVisitPurposes();
  }, []);

  useEffect(() => {
    if (form.department_id) {
      fetchUsers(form.department_id);
    }
  }, [form.department_id]);

  const fetchDepartments = async () => {
    try {
      const res = await axios.post(DEPARTMENT_LIST_API, { token, customer_id }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (res.data.success && res.data.departments) {
        const deptOptions = res.data.departments
          .filter(dept => dept.status === 1)
          .map(dept => ({
            value: dept.id,
            label: dept.name
          }));
        setDepartments(deptOptions);
      }
    } catch (err) {
      console.error('Error loading departments:', err);
    }
  };

const fetchVisitorTypes = async () => {
  try {
    const res = await axios.post(VISITOR_TYPES_LIST_API, { token, customer_id });
    if (res.data.success) {
      const types = res.data.types
        .filter(t => t.status === 1)
        .map(t => ({ value: t.id, label: t.type_name })); // ✅ ID instead of name
      setVisitorTypes(types);
    }
  } catch (err) {
    console.error('Error fetching visitor types:', err);
  }
};

const fetchVisitPurposes = async () => {
  try {
    const res = await axios.post(VISIT_PURPOSE_LIST_API, { token, customer_id });
    if (res.data.success) {
      const purposes = res.data.purposes
        .filter(p => p.status === 1)
        .map(p => ({ value: p.id, label: p.purpose_name })); // ✅ ID instead of name
      setVisitPurposes(purposes);
    }
  } catch (err) {
    console.error('Error fetching visit purposes:', err);
  }
};

  const fetchUsers = async (department_id) => {
    try {
      const res = await axios.post(CLIENT_USERS_LIST_API, {
        customer_id,
        department_id
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (res.data.success && res.data.users) {
        const options = res.data.users.map(user => ({
          value: user.id,
          label: `${user.name} (${user.department_name}, ${user.mobile})`
        }));
        setUserOptions(options);
      }
    } catch (err) {
      console.error('Error fetching users:', err);
    }
  };

  return (
    <div className="row">
      <div className="col-md-6">
        <label className="form-label">Type of Visitor</label>
    <Select
  options={visitorTypes}
  placeholder="Select visitor type"
  value={visitorTypes.find(opt => opt.value === form.visitor_type_id) || null}
  onChange={(selected) => setForm({ ...form, visitor_type_id: selected?.value })}
/>
      </div>

      <div className="col-md-6">
        <label className="form-label">Purpose of Visit</label>
       <Select
  options={visitPurposes}
  placeholder="Select visit purpose"
  value={visitPurposes.find(opt => opt.value === form.visit_purpose_id) || null}
  onChange={(selected) => setForm({ ...form, visit_purpose_id: selected?.value })}
/>
      </div>

      <div className="col-md-6 mt-3">
        <label className="form-label">Select Department</label>
        <Select
          options={departments}
          placeholder="Select department"
          value={departments.find(opt => opt.value === form.department_id) || null}
          onChange={(selectedOption) => {
            setForm({ ...form, department_id: selectedOption?.value, whomToVisit: '' });
          }}
        />
      </div>

      <div className="col-md-6 mt-3">
        <label className="form-label">Whom to Visit</label>
        <Select
          classNamePrefix="react-select"
          options={userOptions}
          isSearchable
          placeholder="Search and select user"
          value={userOptions.find(opt => opt.value === form.whomToVisit) || null}
          onChange={(selectedOption) => setForm({ ...form, whomToVisit: selectedOption?.value })}
          isDisabled={!form.department_id}
        />
      </div>
    </div>
  );
}

export default VisitInfoTab;
